// API del cliente para gestionar sus perfiles de facturación.
// Cada llamada va contra una RPC SECURITY DEFINER que valida que el perfil
// es del usuario autenticado (auth.uid()).

import { supabase } from './supabase'

/** Lista todos mis perfiles activos. Default primero. */
export async function getMisPerfilesFacturacion() {
  const { data, error } = await supabase.rpc('cliente_get_mis_perfiles_facturacion')
  if (error) { console.error('getMisPerfilesFacturacion:', error); return [] }
  return data || []
}

/**
 * Crea un perfil de facturación.
 * @param {Object} p
 * @param {'consumidor_final'|'empresa'} p.tipo
 * @param {string} p.alias                Etiqueta legible ("Personal", "Mi SAS")
 * @param {string} [p.razonSocial]        Obligatorio si tipo=empresa
 * @param {string} [p.rut]                Obligatorio si tipo=empresa (validado server-side)
 * @param {string} [p.direccionFiscal]
 * @param {string} [p.telefonoFiscal]
 * @param {string} [p.emailFiscal]
 * @param {boolean} [p.esDefault=false]   Si true, deja a este como default (desmarca los demás)
 */
export async function crearPerfilFacturacion(p) {
  const { data, error } = await supabase.rpc('cliente_crear_perfil_facturacion', {
    p_tipo:             p.tipo,
    p_alias:            p.alias,
    p_razon_social:     p.razonSocial || null,
    p_rut:              p.rut || null,
    p_direccion_fiscal: p.direccionFiscal || null,
    p_telefono_fiscal:  p.telefonoFiscal || null,
    p_email_fiscal:     p.emailFiscal || null,
    p_es_default:       !!p.esDefault,
  })
  if (error) throw error
  return data
}

export async function actualizarPerfilFacturacion(id, p) {
  const { data, error } = await supabase.rpc('cliente_actualizar_perfil_facturacion', {
    p_id:               id,
    p_alias:            p.alias,
    p_razon_social:     p.razonSocial || null,
    p_rut:              p.rut || null,
    p_direccion_fiscal: p.direccionFiscal || null,
    p_telefono_fiscal:  p.telefonoFiscal || null,
    p_email_fiscal:     p.emailFiscal || null,
  })
  if (error) throw error
  return data
}

export async function eliminarPerfilFacturacion(id) {
  const { error } = await supabase.rpc('cliente_eliminar_perfil_facturacion', { p_id: id })
  if (error) throw error
}

export async function setDefaultPerfilFacturacion(id) {
  const { error } = await supabase.rpc('cliente_set_default_perfil_facturacion', { p_id: id })
  if (error) throw error
}
